import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Lang } from '../i18n';

interface LangCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
}

/** Idioma por defecto: español. Solo se respeta un valor guardado válido ('es' | 'en'). */
const DEFAULT_LANG: Lang = 'es';

const Ctx = createContext<LangCtx>({ lang: DEFAULT_LANG, setLang: () => {} });

function readStoredLang(): Lang {
  try {
    const stored = localStorage.getItem('quipus_lang');
    return stored === 'es' || stored === 'en' ? stored : DEFAULT_LANG;
  } catch {
    return DEFAULT_LANG;
  }
}

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(readStoredLang);

  function setLang(l: Lang) {
    setLangState(l);
    try { localStorage.setItem('quipus_lang', l); } catch { /* metadata de UI: no crítica */ }
  }

  return <Ctx.Provider value={{ lang, setLang }}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
